import ContactDirectory from "@/components/ContactDirectory";

export default function Suppliers({ initialQuery = "" }) {
  return (
    <ContactDirectory
      initialQuery={initialQuery}
      title="Suppliers"
      subtitle="Your vendor contact directory."
      endpoint="/suppliers"
      prefix="supplier"
      singular="supplier"
      addLabel="Add supplier"
      supplierMode
    />
  );
}
